<script lang="ts" setup>
import { useStore } from '@nanostores/vue'
import { computed, ref } from 'vue'
import instanceNotification, {
	NotificationTab,
	NotificationType,
} from '@/assets/ts/notification'
import BsNotificationListItem from '@/legacy/components/NotificationListItem.vue'
import BsNotificationTab from '@/legacy/components/NotificationTab.vue'
import BsSelectPanel from '@/legacy/components/SelectPanel.vue'
import BsSnackBar from '@/legacy/components/SnackBar.vue'
import getTextFromConsole from '@/legacy/ts/getTextFromConsole'
import useSnackBar from '@/legacy/ts/useSnackBar'
import { isLogin } from '@/store/userStore'

const { isShow, messages, addMessage, dismiss } = useSnackBar()
const isLoading = ref(true)
const isShowOptionPanel = ref(false)
const currentOption = ref('')
const isLoginGlobal = useStore(isLogin)
const optionList = computed(() => {
	const optionAll = {
		value: NotificationTab.ALL,
		label: getTextFromConsole('notification_option_panel_label_all'),
	}
	const optionOrder = {
		value: NotificationTab.NOTIFICATION_TYPE_CORE,
		label: getTextFromConsole('notification_option_panel_label_order'),
	}
	const optionAccount = {
		value: NotificationTab.NOTIFICATION_TYPE_ACCOUNT,
		label: getTextFromConsole('notification_option_panel_label_account'),
	}
	if (
		instanceNotification.currentTab === NotificationTab.NOTIFICATION_TYPE_CORE
	) {
		return [optionAll, optionOrder]
	}
	if (
		instanceNotification.currentTab ===
		NotificationTab.NOTIFICATION_TYPE_ACCOUNT
	) {
		return [optionAll, optionAccount]
	}
	return [optionAll]
})

const currentMessage = computed(() => {
	if (messages.value.length) {
		return messages.value[0]
	}
	return ''
})

function showOptionPanel() {
	isShowOptionPanel.value = true
}

function finishSelectOption(value: any) {
	if (value) {
		const payload = {
			type: value,
			APItype:
				value === NotificationTab.ALL
					? NotificationType.all
					: instanceNotification.currentType,
		}
		instanceNotification
			.updateList(payload)
			.then(() =>
				addMessage(getTextFromConsole('snack_bar_notification_read_success')),
			)
			.catch(error => {
				console.error(error)
				addMessage(getTextFromConsole('snack_bar_notification_read_fail'))
			})
	}
}

;(async () => {
	if (isLoginGlobal.value) {
		await instanceNotification.fetchList()
	}
	isLoading.value = false
})()

defineExpose({
	showOptionPanel,
})
</script>

<template>
	<div>
		<BsNotificationTab />
		<div class="bs-notification-list__wrapper">
			<template v-if="isLoading">
				<BsNotificationListItem
					v-for="(item, index) in 5"
					:key="index"
					:isLoading="true"
				/>
			</template>
			<template v-else>
				<template v-if="instanceNotification.listCurrent.length">
					<BsNotificationListItem
						v-for="item in instanceNotification.listCurrent"
						:key="`${item.type}_${item.id}`"
						:itemInfo="item"
					/>
				</template>
				<template v-else>
					<div class="bs-notification-list__empty">
						<div class="bs-notification-list__empty__img"></div>
						<span class="bs-notification-list__empty__count">
							{{ getTextFromConsole('notification_list_empty_title') }}
						</span>
					</div>
				</template>
			</template>
		</div>
		<BsSelectPanel
			:title="getTextFromConsole('notification_option_panel_title')"
			:options="optionList"
			:isShowPanel="isShowOptionPanel"
			:value="currentOption"
			@change="(val: any) => (isShowOptionPanel = val)"
			@hide="isShowOptionPanel = false"
			@finishSelect="finishSelectOption"
		></BsSelectPanel>
		<Teleport to="body">
			<BsSnackBar
				:content="currentMessage"
				:is-show="isShow"
				@dismiss="dismiss"
			></BsSnackBar>
		</Teleport>
	</div>
</template>
